import { render, staticRenderFns } from "./activitiesManageList.vue?vue&type=template&id=53e67559&scoped=true"
import script from "./activitiesManageList.vue?vue&type=script&lang=js"
export * from "./activitiesManageList.vue?vue&type=script&lang=js"
import style0 from "./activitiesManageList.vue?vue&type=style&index=0&id=53e67559&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e67559",
  null
  
)

export default component.exports